import {observeTopics, saveTopic} from "./Topic.repository";
import {useCallbackState, useObserverState} from "../app/data/State.hooks";

export const useTopics = () => useObserverState(observeTopics(), []);

export const useTopicSaveAction = () => useCallbackState(saveTopic, []);
